<template>
  <div class="common-container">
    <div class="news">
      <div class="title">新闻资讯</div>
      <div class="content">
        <div class="c-left">
          <news-classify :classify-id.sync="classifyId"/>
        </div>
        <div class="c-right">
          <el-empty v-if="resultData.list.length < 1" description="暂无信息"></el-empty>
          <div class="news-list" v-else>
            <div class="news-item" v-for="(v,i) in resultData.list" :key="i">
              <news-item :data="v"/>
            </div>
          </div>
          <el-pagination
              v-if="resultData.list.length > 0"
              @current-change="currentPageChange"
              :page-size="5"
              layout="total, prev, pager, next, jumper"
              :total="resultData.count">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NewsClassify from "./components/Classify.vue";
import NewsItem from "./components/Item.vue";
import {getCity} from "@/utils/locate";

export default {
  name: "News",
  components: {NewsClassify, NewsItem},
  data() {
    return {
      resultData: {
        list: [],
        count: 0
      },
      page: 1,
      classifyId: 1
    }
  },
  watch: {
    '$route.query.classifyId': {
      immediate: true,
      handler(val) {
        if (val) {
          this.classifyId = val
        }
      }
    },
    classifyId: {
      immediate: true,
      handler() {
        this.getDataList()
      }
    }
  },
  computed: {
    city() {
      return getCity()
    }
  },
  methods: {
    /**
     * 获取
     */
    getDataList() {
      const params = {
        classifyId: this.classifyId,
        page: this.page,
        areaId: this.city.areaId
      }
      this.$request.get('/News/pageList', {
        params
      }).then(res => {
        if (res.code === 0) {
          this.resultData = res.data
        }
      })
    },
    /**
     * 翻页
     **/
    currentPageChange(current) {
      this.page = current
      this.getDataList()
    }
  }
}
</script>

<style scoped lang="scss">
.news {
  width: 1200px;
  padding: 30px 0 60px 0;
  display: flex;
  flex-direction: column;
  align-items: center;

  .title {
    color: #2D2D2D;
    font-size: 38px;
    font-weight: bold;
    margin-bottom: 30px;
  }

  .content {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: flex-start;

    .c-left {
      display: flex;
      flex-direction: column;
    }

    .c-right {
      flex: 1;
      width: 0;
      display: flex;
      flex-direction: column;

      .news-list {
        display: flex;
        flex-direction: column;

        .news-item {
          margin-bottom: 20px;
        }
      }

      .el-pagination {
        text-align: center;
        margin-top: 30px;

        ::v-deep {
          button, .el-pager li, .el-input__inner {
            background-color: transparent !important;
          }
        }
      }
    }
  }
}
</style>